/** Сброс сессии конфигуратора: новый проект (без projectId), очистка стейта, следующее сохранение создаёт новую запись. */
export const APP_START_NEW_PROJECT = 'welland:start-new-project';

/** Событие окна: открыть модалку «Быстрый выбор от Welland» из центра управления. */
export const SITE_CONTROL_OPEN_QUICK_SELECTION = 'welland:open-quick-selection';

/** Подсветка кнопки «Быстрый выбор» (например, после совета AI). detail: { active?: boolean } */
export const SITE_CONTROL_HIGHLIGHT_QUICK_SELECTION = 'welland:highlight-quick-selection';

/** Событие: переключить показ блока «Параметры бассейна» в левом редакторе. */
export const SITE_CONTROL_TOGGLE_POOL_PARAMS = 'welland:toggle-pool-params';

/** Событие: переключить показ блока «Техническая информация» в левом редакторе. */
export const SITE_CONTROL_TOGGLE_TECHNICAL_INFO = 'welland:toggle-technical-info';

/** Синхронизация: видимость блока «Параметры бассейна» (для обводки в нижней плашке). detail: { visible: boolean } */
export const SITE_CONTROL_SYNC_POOL_PARAMS_VISIBLE = 'welland:sync-pool-params-visible';

/** Синхронизация: видимость «Техническая информация». detail: { visible: boolean } */
export const SITE_CONTROL_SYNC_TECHNICAL_INFO_VISIBLE = 'welland:sync-technical-info-visible';

/** Нижняя плашка запрашивает актуальную видимость блоков у PoolEditor (после монтирования слушателей). */
export const SITE_CONTROL_REQUEST_POOL_EDITOR_SYNC = 'welland:request-pool-editor-sync';

/** Событие сцены: включить/выключить «2D режим» (для UI/камеры). */
export const SCENE_VIEW_SET_2D_MODE = 'welland:scene-set-2d-mode';

/** Событие сцены: обновить zoom в 2D режиме (в процентах). */
export const SCENE_VIEW_SET_ZOOM_PERCENT = 'welland:scene-set-zoom-percent';

/** Событие сцены: синхронизировать zoom% из камеры в UI (актуально для 3D wheel). */
export const SCENE_VIEW_SYNC_ZOOM_PERCENT = 'welland:scene-sync-zoom-percent';
